import { Box, Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    form_row: {
      marginBottom: theme.spacing(1),
    },
  })
)

interface Props {
  children?: any
}

export const FormRow: React.FC<Props> = ({ children }) => {
  const classes = useStyles()
  return <Box className={classes.form_row}>{children}</Box>
}
